webpackJsonp([915738553496],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imformationComplianceEn = function imformationComplianceEn() {
	    return _react2.default.createElement(
	        "section",
	        { id: "architecture", className: "parallax-section" },
	        _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 col-sm-12 wow fadeInUp", "data-wow-delay": "0.1s" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "team-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "section-title col-md-12" },
	                                _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    "Informative Note on the Personal Data Collected throughout the DevExperience Conference"
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 col-sm-12 wow fadeInUp", "data-wow-delay": "0.1s" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "team-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12" },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "You accessed the website https://devexperience.ro/ for the purpose of on-line filling in of the registration form for the participation in the DevExperience Conference 2019 organised by ITS WISE SRL (hereinafter referred to as It\u2019s Wise or Conference Organiser) or for the purpose of informing oneself regarding the conference.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "ITS WISE SRL, with registered office in Ia\u0219i Municipality, Centris Building, 17 Colonel Langa St., registered with the Trade Register under no. J22/1839/2014, URC RO33877160, telephone +40758077920, e-mail contact@devexperience.ro, is a personal data operator.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Taking into consideration the implementation on 25.05.2019 of Regulation (EU) 679/2016 - General Regulation on personal data protection and the free movement of the data (hereinafter referred to as GDPR), we wish to inform you, in compliance with art. 13 of GDPR, regarding the following aspects on the manner in which the conference organiser applies and complies with the provisions of the European Regulation invoked."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Purposes, Legal Grounds and Types of Personal Data Processes:"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "1. For the purpose of executing the formalities regarding your enrolment into the DevExperience Conference 2019 and for the purpose of meeting the legal obligations we undertook, the following personal data categories shall be processes:",
	                                    _react2.default.createElement("br", null),
	                                    "a. ",
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "identification data"
	                                    ),
	                                    " (last and first name); b. ",
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "contact data"
	                                    ),
	                                    " (email address, address to which we shall send the invoice and optionally, if we cannot contact you via email, telephone number); The data shall be collected by means of a Google Docs form."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "2. For the purpose of ",
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "informing you regarding changes in the conference agenda"
	                                    ),
	                                    " (telephone no., email address), having as legal grounds the legitimate interest of IT\u2019s Wise of carrying out the conference under good conditions."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "3. For the purpose of promoting future conferences, group photographies or video recordings shall be taken. Taking into consideration the number of participants, in order to not disturb the good performance of the Conference, we believe that the measure of obtaining a written consent would be disproportionate with this processing purpose. If you wish to not be photographed or filmed or if you appear in an image due to reasons independent of your will, we inform you that you have the possibility to exercise the rights detailed below."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Sending data to third parties"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "Personal data shall be obtained for purposes 1 and 2 described above, shall not be sent to third parties and shall not be made public.",
	                                    _react2.default.createElement("br", null),
	                                    "Personal data (group photographies or video images) obtained for the 3rd purpose, shall be published on the conference website."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Processing period"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "We shall keep your personal data only for as long as it is necessary for the purpose of meeting the purposes stated, in compliance with internal procedures on data maintenance and security, including the archiving rules used at the level of the company or of the legal terms requested by the tax law. We guarantee that the maintenance of your data shall be carried out only due to legal reasons, in compliance with their confidentiality and security."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Your rights"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "In compliance with the provisions of Regulation (EU) 679/2016, you shall benefit from the following rights:",
	                                    _react2.default.createElement(
	                                        "ul",
	                                        { className: "privacy-ul" },
	                                        _react2.default.createElement(
	                                            "li",
	                                            null,
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "access right"
	                                            ),
	                                            " (you have access right to the personal data processed and to information regarding the means of processing);"
	                                        ),
	                                        _react2.default.createElement(
	                                            "li",
	                                            null,
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "right to rectification"
	                                            ),
	                                            " (correction by the operator of incorrect/inaccurate personal data);"
	                                        ),
	                                        _react2.default.createElement(
	                                            "li",
	                                            null,
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "right to opposition"
	                                            ),
	                                            " (possibility to oppose processing);"
	                                        ),
	                                        _react2.default.createElement(
	                                            "li",
	                                            null,
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "right to deletion"
	                                            ),
	                                            " (the right to request the deletion of collected data when these are not necessary for the performance of the purposes for which they were collected, when there is no legal grounds for the processing, when you consider that the data were illegally processed or for the compliance with a legal obligation);"
	                                        ),
	                                        _react2.default.createElement(
	                                            "li",
	                                            null,
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "right to restrict the processing"
	                                            ),
	                                            " (it allows you to obtain the restriction to process your personal data in certain cases, for instance when you consider that the processing is illegal, for a period of time which allows us to check the aspects signalled by you);"
	                                        ),
	                                        _react2.default.createElement(
	                                            "li",
	                                            null,
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "right to data portability"
	                                            ),
	                                            " (although we consider that it is not the case, we inform you that this right allows you to receive the personal data you supplied us, in a structured format, commonly used and legible, or to send the data to another data operator)."
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "p",
	                                        null,
	                                        "At the same time, if you consider that the data processing is carried out in violation of the provisions of Regulation (EU) 679/2016, we inform you that you can exercise the rights via the following manners: by sending a written, dated and signed application to the address: ITS WISE SRL, Ia\u0219i, Cl\u0103direa Centris, Strada Colonel Langa nr.17; via a message sent to the email address\xA0",
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "mailto:contact@devexperience.ro" },
	                                            "contact@devexperience.ro"
	                                        ),
	                                        "\xA0or by calling to the telephone number +40758077920. Moreover, you have the right to submit a complaint to the National Supervisory Authority for Personal Data Processing (28-30 B-dul Gheorghe Magheru, District 1, post code 010336 BUCHAREST, telephone: 0318059211, email address:\xA0",
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "mailto:anspdcp@dataprotection.ro" },
	                                            "anspdcp@dataprotection.ro"
	                                        ),
	                                        ")."
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Technical and organisational measures for personal data protection"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "The Organiser laid down organisational and technical measures for the compliance with the provisions of Regulation (EU) 679/2016, which ensure the legality of personal data processing, as well as their safety."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Existence of an automated decision-making process including the creation of profiles"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "Your personal data are not processed for the purpose of a decision-making process or the creation of profiles."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        "Supply of personal data necessary for the compliance with a legal obligation of the operator"
	                                    ),
	                                    _react2.default.createElement("br", null),
	                                    "We inform you that the existing legal provisions, which regulate the conditions for the drafting of the invoice, force us to request and to process the categories of personal data listed in paragraph 1."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "In this context, to the extent that you do not express your consent for the processing of the personal data above-mentioned, you shall not be able to participate in the DevExperience Conference 2019 organised by ITS WISE SRL."
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = imformationComplianceEn;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-6c69c8ba7184eb962821.js